/**
 * -----------------------------------------------------------------------------
 * It renders a caret right outlined icon
 */
export function CaretRightOutlined() {
  return (
    <svg
      className="rtl:scale-x-[-1]"
      fill="none"
      height={20}
      width={11}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="stroke-gray-400"
        d="m1 1 8.744 8.406A.839.839 0 0 1 10 10a.812.812 0 0 1-.256.594L1 19"
      />
    </svg>
  );
}
